<template>
  <div class="ph-special-main ">
    <el-backtop ></el-backtop>
    <hpheader v-if="showHeader"></hpheader>

<!--    <div class="special-body">-->
<!--      <position-bar :positionNav="positionNav">-->
<!--      </position-bar>-->
<!--      <div class="banner-container" ref="bannerContainerRef">-->
<!--        <div class="banner" ref="bannerRef">-->
<!--          <img  src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/fed8906ffd3524329bb617f143ccfd3d.jpg" alt="">-->
<!--          <p class="banner-title">让预备更智能</p>-->
<!--          <img @load="onImageLoad" class="product-banner"  src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/a75ef6a5e9017736414456a651e30bfa.png" alt="">-->
<!--        </div>-->
<!--&lt;!&ndash;        <div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="banner-logo">&ndash;&gt;-->
<!--&lt;!&ndash;            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260111/b2854b2be4cd927e35478aa0f52897b8.jpg" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="banner-title">&ndash;&gt;-->
<!--&lt;!&ndash;            The Future of Endodontics&ndash;&gt;-->
<!--&lt;!&ndash;          </p>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="banner">&ndash;&gt;-->
<!--&lt;!&ndash;            <img @load="onImageLoad" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/410fece615b99fa9e28be79c0929bd76.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <div class="preview-video-container" ref="previewVideoContainerRef">-->
<!--          &lt;!&ndash;          <div class="preview-video-box" ref="previewVideoBoxRef">&ndash;&gt;-->
<!--          &lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div class="preview-video-text pl-100 pr-100" ref="previewVideoTextRef">-->
<!--            <div class="flex">-->
<!--              <p class="tit">扭矩更稳</p>-->
<!--              <p class="tit ml-150">测量更准</p>-->
<!--            </div>-->
<!--            <div class="flex">-->
<!--              <p class="tit">弯曲更易</p>-->
<!--              <p class="tit ml-150">锉序列自定义</p>-->
<!--            </div>-->
<!--            <endo-button @onclick="openVideoModal(videoList[0].previewVideo)"></endo-button>-->
<!--          </div>-->
<!--          <div class="preview-video-box">-->
<!--            <div class="progress">-->
<!--              <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>-->
<!--            </div>-->
<!--            <video class="background-video"-->
<!--                   :ref="videoList[0].ref"-->
<!--                   :src="videoList[0].video"-->
<!--                   muted-->
<!--                   playsinline-->
<!--                   loop-->
<!--                   autoplay-->
<!--            ></video>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="section-product-desc">-->
<!--        <div class="product-logo">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/87e903851c3d897212cbc769f7cbf820.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-logo-text">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/67e1d823677d4b4c5aff4dcee4305af0.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-image">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251231/8bd325f95eeb52a77358086b920657f5.jpg" alt="">-->
<!--        </div>-->
<!--        <div class="product-special-title pl-100 pr-100">-->
<!--          <div class="product-special-title-b">-->
<!--            <h5>智能扭矩 预备更自如</h5>-->
<!--            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="product-detail-text1 pl-100 pr-100">-->
<!--          <p class="txt">-->
<!--            在连续锉模式下<br/>-->
<!--            可实时分析牙本质阻力<br/>-->
<!--            自动匹配根管不同区域所需扭矩<br/>-->
<!--            在确保高效切削的同时<br/>-->
<!--            有效降低扭转疲劳与锉断风险<br/>-->
<!--          </p>-->
<!--          &lt;!&ndash;          <p class="txt">for real-time torque determination that analyzes</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">the cutting resistance of files against the dentin</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">wall. The Endo GT Series learns the torque needed</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">to cut through dentin and automatically adjusts to</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">set the ideal torque for each section of the canal.</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">This ensures that cutting power is tailored to the</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">task while protecting against torsional fatigue and</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">file separation.</p>&ndash;&gt;-->
<!--          <endo-button @onclick="openVideoModal(videoList[1].previewVideo)"></endo-button>-->
<!--        </div>-->

<!--        <div class="product-video-container">-->
<!--          <div class="progress">-->
<!--            <circular-progress :progress="videoList[1].progress" :isPlaying="videoList[1].playing" index="1" @togglePlay="togglePlay"/>-->
<!--          </div>-->
<!--          <video class="product-video"-->
<!--                 :ref="videoList[1].ref"-->
<!--                 :src="videoList[1].video"-->
<!--                 muted-->
<!--                 playsinline-->
<!--                 loop-->
<!--                 autoplay-->
<!--          ></video>-->
<!--        </div>-->

<!--        <div class="product-detail-text1 product-detail-text2 pl-100 pr-100">-->
<!--          <p class="txt">-->
<!--            马达持续监测扭矩并自动设定安全阈值<br/>-->
<!--            扭矩超限时自动切换往复模式<br/>-->
<!--            不同锉型无需单独设定扭矩<br/>-->
<!--          </p>-->
<!--        </div>-->

<!--        <div class="step-list pl-100 pr-100">-->
<!--          <div class="step-item video-container">-->
<!--            &lt;!&ndash;            <div class="progress">&ndash;&gt;-->
<!--            &lt;!&ndash;              <circular-progress :progress="videoList[2].progress" :isPlaying="videoList[2].playing" index="2" @togglePlay="togglePlay"/>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            &lt;!&ndash;            <video class="step-video-1"&ndash;&gt;-->
<!--            &lt;!&ndash;                   :ref="videoList[2].ref"&ndash;&gt;-->
<!--            &lt;!&ndash;                   :src="videoList[2].video"&ndash;&gt;-->
<!--            &lt;!&ndash;                   muted&ndash;&gt;-->
<!--            &lt;!&ndash;                   playsinline&ndash;&gt;-->
<!--            &lt;!&ndash;                   loop&ndash;&gt;-->
<!--            &lt;!&ndash;                   autoplay&ndash;&gt;-->
<!--            &lt;!&ndash;            ></video>&ndash;&gt;-->
<!--            &lt;!&ndash;            <div class="step-video-txt">&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="step-video-title">&ndash;&gt;-->
<!--            &lt;!&ndash;                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">&ndash;&gt;-->
<!--            &lt;!&ndash;                <h5>Step 1</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              <p class="txt-big mt-15">2<span class="txt-middle">s</span></p>&ndash;&gt;-->
<!--            &lt;!&ndash;              <p class="txt-small">Learning</p>&ndash;&gt;-->
<!--            &lt;!&ndash;              <p class="txt-small">torque</p>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="step-image">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/a36e73f0a9669a7877954c07ac76afb3.png" alt=""></img>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="step-item video-container">-->
<!--            &lt;!&ndash;            <div class="progress">&ndash;&gt;-->
<!--            &lt;!&ndash;              <circular-progress :progress="videoList[3].progress" :isPlaying="videoList[3].playing" index="3" @togglePlay="togglePlay"/>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            &lt;!&ndash;            <video class="step-video-2"&ndash;&gt;-->
<!--            &lt;!&ndash;                   :ref="videoList[3].ref"&ndash;&gt;-->
<!--            &lt;!&ndash;                   :src="videoList[3].video"&ndash;&gt;-->
<!--            &lt;!&ndash;                   muted&ndash;&gt;-->
<!--            &lt;!&ndash;                   playsinline&ndash;&gt;-->
<!--            &lt;!&ndash;                   loop&ndash;&gt;-->
<!--            &lt;!&ndash;                   autoplay&ndash;&gt;-->
<!--            &lt;!&ndash;            ></video>&ndash;&gt;-->
<!--            &lt;!&ndash;            <div class="step-video-txt">&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="step-video-title">&ndash;&gt;-->
<!--            &lt;!&ndash;                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">&ndash;&gt;-->
<!--            &lt;!&ndash;                <h5>Step 2</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              <p class="txt-small mt-25">Auto-set</p>&ndash;&gt;-->
<!--            &lt;!&ndash;              <p class="txt-small">the ideal</p>&ndash;&gt;-->
<!--            &lt;!&ndash;              <p class="txt-small">torque</p>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="step-image">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/49bae48679adacd9c702f4339c770d3a.png" alt=""></img>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="step-item video-container">-->
<!--            &lt;!&ndash;            <div class="progress">&ndash;&gt;-->
<!--            &lt;!&ndash;              <circular-progress :progress="videoList[4].progress" :isPlaying="videoList[4].playing" index="4" @togglePlay="togglePlay"/>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            &lt;!&ndash;            <video class="step-video-3"&ndash;&gt;-->
<!--            &lt;!&ndash;                   :ref="videoList[4].ref"&ndash;&gt;-->
<!--            &lt;!&ndash;                   :src="videoList[4].video"&ndash;&gt;-->
<!--            &lt;!&ndash;                   muted&ndash;&gt;-->
<!--            &lt;!&ndash;                   playsinline&ndash;&gt;-->
<!--            &lt;!&ndash;                   loop&ndash;&gt;-->
<!--            &lt;!&ndash;                   autoplay&ndash;&gt;-->
<!--            &lt;!&ndash;            ></video>&ndash;&gt;-->
<!--            &lt;!&ndash;            <div class="step-video-txt">&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="step-video-title">&ndash;&gt;-->
<!--            &lt;!&ndash;                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">&ndash;&gt;-->
<!--            &lt;!&ndash;                <h5>Step 3</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              <p class="txt-small mt-25">Reciprocation</p>&ndash;&gt;-->
<!--            &lt;!&ndash;              <p class="txt-small">if torque is</p>&ndash;&gt;-->
<!--            &lt;!&ndash;              <p class="txt-small">surpassed</p>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="step-image">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/e76d7a306f1a7cd91ae7a8ac7cde9caf.png" alt=""></img>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="section-product-suit section-product-desc">-->
<!--        <div class="product-logo">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/fd75dc0a2eb9cc522f4458e6482640d0.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-logo-text">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/ef9dacf873710fd3a4777acd9297cc29.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-special-title pl-100 pr-100">-->
<!--          <div class="product-special-title-b">-->
<!--            <p class="tit">稳定测量 更准更清晰</p>-->
<!--            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="product-detail-text1 pl-100 pr-100">-->
<!--          <p class="txt">-->
<!--            电子测量若不稳定<br/>-->
<!--            容易造成根尖定位误差<br/>-->
<!--            ClearSignal™ 技术可实时评估信号稳定性<br/>-->
<!--            帮助判断连接是否可靠<br/>-->
<!--            提升根尖测量的准确性<br/>-->
<!--          </p>-->
<!--          &lt;!&ndash;          <p class="txt">can lead to inaccurate readings. ClearSignal™</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">technology evaluates the strength of the electronic</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">signal, helping determine whether the connection is</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <p class="txt">reliable for accurately locating the foramen exit.</p>&ndash;&gt;-->
<!--          <endo-button @onclick="openVideoModal(videoList[5].previewVideo)"></endo-button>-->
<!--        </div>-->

<!--        <div class="g-preview-video-container product-video-container">-->
<!--          &lt;!&ndash;          <div class="progress">&ndash;&gt;-->
<!--          &lt;!&ndash;            <circular-progress :progress="videoList[5].progress" :isPlaying="videoList[5].playing" index="5" @togglePlay="togglePlay"/>&ndash;&gt;-->
<!--          &lt;!&ndash;          </div>&ndash;&gt;-->
<!--          &lt;!&ndash;          <video class="g-preview-video product-video"&ndash;&gt;-->
<!--          &lt;!&ndash;                 :ref="videoList[5].ref"&ndash;&gt;-->
<!--          &lt;!&ndash;                 :src="videoList[5].video"&ndash;&gt;-->
<!--          &lt;!&ndash;                 muted&ndash;&gt;-->
<!--          &lt;!&ndash;                 playsinline&ndash;&gt;-->
<!--          &lt;!&ndash;                 loop&ndash;&gt;-->
<!--          &lt;!&ndash;                 autoplay&ndash;&gt;-->
<!--          &lt;!&ndash;          ></video>&ndash;&gt;-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/9c23d06af668398f4938108855ca1e13.jpg" alt="">-->
<!--        </div>-->

<!--        <div class="product-detail-text1 product-detail-text2 product-detail-text3 pl-100 pr-100">-->
<!--          <p class="txt">系统可同步显示电子信号稳定性<br/>-->
<!--            轻触仪表盘即可获得屏幕提示与引导</p>-->
<!--        </div>-->

<!--        <div class="g-mode-video-container product-video-container">-->
<!--          <div class="progress">-->
<!--            <circular-progress :progress="videoList[6].progress" :isPlaying="videoList[6].playing" index="6" @togglePlay="togglePlay"/>-->
<!--          </div>-->
<!--          <video class="g-mode-video product-video"-->
<!--                 :ref="videoList[6].ref"-->
<!--                 :src="videoList[6].video"-->
<!--                 muted-->
<!--                 playsinline-->
<!--                 loop-->
<!--                 autoplay-->
<!--          ></video>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="improved-container">-->
<!--        <div class="improved-banner-text pl-100 pr-100">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <p class="tit">先进弯手机控制技术</p>-->
<!--            </div>-->
<!--            <div class="product-special-title-p">-->
<!--              <p>可精准适配多类型锉型的往复角度<br/>-->
<!--                并快速切换 TorqueSense、<br/>-->
<!--                ATR 等运动模式<br/>-->
<!--                操作响应更迅速，也更贴合临床需求</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="improved-banner">-->
<!--          <img @load="onImprovedBanner" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260102/660f8002e2ec712d55eaceb9a66012e4.jpg" alt="">-->
<!--        </div>-->
<!--        <div class="improved-content pl-100 pr-100" ref="improvedContentRef">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <p class="tit">多重保护</p>-->
<!--              <p class="tit">让根管预备更可控</p>-->
<!--              <p class="tit">更安心</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="improved-content-detail">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <p class="tit">根尖动态预警：操作心中有数</p>-->
<!--              </div>-->
<!--              <div class="product-special-title-p">-->
<!--                <p>声光渐进提示：锉针接近根尖时，提示音由弱渐-->
<!--                  强，到达根尖LED指示灯同步闪烁提示，动态提-->
<!--                  示预备深度。<br/>-->
<!--                  动态轨迹监测：屏幕实时显示锉针在根管内的位-->
<!--                  置趋势，让操作一目了然。</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <p class="tit">智能预设控制：多种自动辅助</p>-->
<!--              </div>-->
<!--              <div class="product-special-title-p">-->
<!--                <p>进出根管自动启停: 锉针进入根管自动运转，离开即停，简化手动操作。<br/>-->
<!--                  接近根尖自动减速：临近根尖报警点自动降低转-->
<!--                  速，便于医生从容操作。<br/>-->
<!--                  到达根尖智能响应：到达根尖报警点时可设置自-->
<!--                  动反转或自动停止，辅助医生避免过度预备。</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash;        <div class="improved-content" ref="improvedContentRef">&ndash;&gt;-->
<!--        &lt;!&ndash;          <div class="torque-sense">&ndash;&gt;-->
<!--        &lt;!&ndash;            <div class="torque-sense-logo">&ndash;&gt;-->
<!--        &lt;!&ndash;              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/8da99d7895634c11c0388d0b4b68907a.png" alt="">&ndash;&gt;-->
<!--        &lt;!&ndash;            </div>&ndash;&gt;-->
<!--        &lt;!&ndash;            <div class="product-special-title">&ndash;&gt;-->
<!--        &lt;!&ndash;              <div class="product-special-title-b">&ndash;&gt;-->
<!--        &lt;!&ndash;                <h5>TorqueSense</h5>&ndash;&gt;-->
<!--        &lt;!&ndash;              </div>&ndash;&gt;-->
<!--        &lt;!&ndash;              <div class="product-special-title-p">&ndash;&gt;-->
<!--        &lt;!&ndash;                <p>Effortless torque</p>&ndash;&gt;-->
<!--        &lt;!&ndash;                <p>control with precise</p>&ndash;&gt;-->
<!--        &lt;!&ndash;                <p>adjustments</p>&ndash;&gt;-->
<!--        &lt;!&ndash;              </div>&ndash;&gt;-->
<!--        &lt;!&ndash;            </div>&ndash;&gt;-->
<!--        &lt;!&ndash;          </div>&ndash;&gt;-->
<!--        &lt;!&ndash;          <div class="atr-mode">&ndash;&gt;-->
<!--        &lt;!&ndash;            <div class="atr-mode-logo">&ndash;&gt;-->
<!--        &lt;!&ndash;              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/173dba0a4e426292c168e6b19dcad79b.png" alt="">&ndash;&gt;-->
<!--        &lt;!&ndash;            </div>&ndash;&gt;-->
<!--        &lt;!&ndash;            <div class="product-special-title">&ndash;&gt;-->
<!--        &lt;!&ndash;              <div class="product-special-title-b">&ndash;&gt;-->
<!--        &lt;!&ndash;                <h5>ATR Mode</h5>&ndash;&gt;-->
<!--        &lt;!&ndash;              </div>&ndash;&gt;-->
<!--        &lt;!&ndash;              <div class="product-special-title-p">&ndash;&gt;-->
<!--        &lt;!&ndash;                <p>Reciprocation is ignited</p>&ndash;&gt;-->
<!--        &lt;!&ndash;                <p>when the torque is</p>&ndash;&gt;-->
<!--        &lt;!&ndash;                <p>surpassedas a safety feature</p>&ndash;&gt;-->
<!--        &lt;!&ndash;              </div>&ndash;&gt;-->
<!--        &lt;!&ndash;            </div>&ndash;&gt;-->
<!--        &lt;!&ndash;          </div>&ndash;&gt;-->
<!--        &lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </div>-->

<!--      <div class="contra-angle-container">-->
<!--        <div class="contra-angle-box">-->
<!--          <div class="contra-angle-banner-text pr-100 pl-100">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <p class="tit">超薄8mm弯机头</p>-->
<!--              </div>-->
<!--              <div class="product-special-title-p">-->
<!--                <p>轻松进入后牙区</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="contra-angle-banner-animate-box">-->
<!--          <div class="contra-angle-banner">-->
<!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260102/747c18d6e68bcd7e2b74f68ea0e5ddfc.jpg" alt=""/>-->
<!--            <div class="contra-angle-banner-text pl-100 pr-100">-->
<!--              <div class="product-special-title">-->
<!--                <div class="product-special-title-b">-->
<!--                  <p class="tit">LED手柄 可调冷光设计</p>-->
<!--                </div>-->
<!--                <div class="flex contra-angle-parameter">-->
<!--                  <div class="bottom-align">-->
<!--                    <div class="product-special-title-b">-->
<!--                      <p class="tit" style="vertical-align: bottom;">≥8000</p>-->
<!--                    </div>-->
<!--                    <div class="product-special-title-p">-->
<!--                      <p>lux</p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="product-special-title-p contra-angle-desc">-->
<!--                  <p>确保视野明亮无阴影</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash;          <div class="contra-angle-banner-text">&ndash;&gt;-->
<!--            &lt;!&ndash;            <div class="product-special-title">&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="product-special-title-b">&ndash;&gt;-->
<!--            &lt;!&ndash;                <h5>Contra-angle</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;                <h5>head with</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;                <h5>LED light</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="flex contra-angle-parameter">&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="bottom-align">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="product-special-title-b">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <h5 style="vertical-align: bottom;">8000</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="product-special-title-p">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <p>lux</p>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="bottom-align">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="product-special-title-b">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <h5>8 mm</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="product-special-title-p">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <p>diameter</p>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="product-special-title-p contra-angle-desc">&ndash;&gt;-->
<!--            &lt;!&ndash;                <p>Ultra-slim 8 mm head for superior access</p>&ndash;&gt;-->
<!--            &lt;!&ndash;                <p>to posterior teeth</p>&ndash;&gt;-->
<!--            &lt;!&ndash;                <p>Adjustable cold light for shadow-free illumination</p>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            &lt;!&ndash;          </div>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="contra-angle-animation">-->
<!--            &lt;!&ndash;          <div class="contra-angle-slider">&ndash;&gt;-->
<!--            &lt;!&ndash;            <i class="dark">&ndash;&gt;-->
<!--            &lt;!&ndash;              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/791eea63527aa78c4a20687435031129.png" alt="">&ndash;&gt;-->
<!--            &lt;!&ndash;            </i>&ndash;&gt;-->
<!--            &lt;!&ndash;            <el-slider v-model="contraAngleSliderValue" :show-tooltip="false" :max="contraAngleBanner.length" @input="listenMove"></el-slider>&ndash;&gt;-->
<!--            &lt;!&ndash;            <i class="light">&ndash;&gt;-->
<!--            &lt;!&ndash;              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/234999d86aa2515b99003560dc84cb3e.png" alt="">&ndash;&gt;-->
<!--            &lt;!&ndash;            </i>&ndash;&gt;-->
<!--            &lt;!&ndash;          </div>&ndash;&gt;-->
<!--            <div class="contra-angle-animation-container pl-100 pr-100">-->
<!--              <img ref="contraAngleAnimationRef" :src="contraAngleBanner[0]" alt="">-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="gradient-background">-->
<!--        <div class="section-build-file">-->
<!--          <div class="pr-100 pl-100">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <div class="flex" style="align-items: flex-end;">-->
<!--                  <p class="tit">锉系统</p>-->
<!--                  <p class="ml-50">Inspired by Dr. Carlos Spirinelli Ramos</p>-->
<!--                </div>-->
<!--                <p class="tit mt-50">全面、灵活，自由掌控</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="product-detail-text1">-->
<!--              <p class="txt">内置常用锉序列，开机即可使用<br/>-->
<!--                系统支持Wi-Fi软件在线升级<br/>-->
<!--                锉库可随软件同步更新，始终紧跟最新标准</p>-->

<!--              <p class="txt mt-77">直观界面支持自定义锉与锉序列<br/>-->
<!--                可按锉号、锥度、长度等参数创建专属锉型<br/>-->
<!--                也可将多品牌锉与自建锉组合为混合序列</p>-->

<!--              <p class="txt mt-77">无论预备通路、MB2 或宽大复杂根管<br/>-->
<!--                皆可构建独立、针对性的操作方案</p>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="section-product-desc">-->
<!--            <div class="build-file-video-container product-video-container">-->
<!--              <div class="progress">-->
<!--                <circular-progress :progress="videoList[7].progress" :isPlaying="videoList[7].playing" index="7" @togglePlay="togglePlay"/>-->
<!--              </div>-->
<!--              <video class="build-file-video product-video"-->
<!--                     :ref="videoList[7].ref"-->
<!--                     :src="videoList[7].video"-->
<!--                     muted-->
<!--                     playsinline-->
<!--                     loop-->
<!--                     autoplay-->
<!--              ></video>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->

<!--        <div class="selection-magnetic">-->
<!--          <div class="product-special-title pl-100 pr-100">-->
<!--            <div class="product-special-title-b">-->
<!--              <p class="tit">手柄与主机无线连接</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="product-detail-text1 pl-100 pr-100">-->
<!--            <p class="txt">磁吸底座轻松对接</p>-->
<!--            <p class="txt mt-77">实现便捷的无接触充电</p>-->
<!--          </div>-->
<!--          <div class="section-product-desc">-->
<!--            <div class="magnetic-video-container product-video-container ">-->

<!--              <div class="progress">-->
<!--                <circular-progress :progress="videoList[8].progress" :isPlaying="videoList[8].playing" index="8" @togglePlay="togglePlay"/>-->
<!--              </div>-->
<!--              <video class="magnetic-video product-video"-->
<!--                     :ref="videoList[8].ref"-->
<!--                     :src="videoList[8].video"-->
<!--                     muted-->
<!--                     playsinline-->
<!--                     loop-->
<!--                     autoplay-->
<!--              ></video>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->




<!--      <div class="section-touch-screen">-->
<!--        <div class="touch-screen-list">-->
<!--          <div class="touch-screen-item pl-100 pr-100">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <p class="tit">6 英寸高清触控屏</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-detail-text1">-->
<!--                <p class="txt">-->
<!--                  在强光下依然清晰可见<br/>-->
<!--                  可戴手套流畅操作<br/>-->
<!--                  快捷预设提升临床效率-->
<!--                </p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="touch-screen-item">-->
<!--            <div class="image pr-100 pl-100">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/f055b846712d32b00ca5269fa5fa8cef.png" alt=""/>-->
<!--            </div>-->
<!--            <div class="image pr-100 pl-100">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/bc98871ecd2c3c870d358a7ff2f71fd5.png" alt=""/>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->

<!--        <div class="section-packaging pl-100 pr-100">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <p class="tit">可降解包装 减轻地球负担</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="product-detail-text1" >-->
<!--            <p class="txt">-->
<!--              我们持续减少塑料的使用。产品包装选用符合严苛环保标准的可生物降解材料，在满足产品保护与使用体验的同时，尽量降低对环境的长期影响。-->
<!--            </p>-->

<!--            <p class="txt mt-77">给地球的礼物，从一份会“消失”的包装开始。</p>-->
<!--          </div>-->

<!--          <div class="image">-->
<!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/69f6de3ab94b8a658f9cfe0bff2a6bc6.jpg" alt=""></img>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="keep-exploring pl-100 pr-100">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <p class="tit">GT全系列</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="keep-exploring-container">-->
<!--            <div class="mode-list">-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/5df5bda98ad17adcec553915da520fa2.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT mini</h5>-->
<!--                </div>-->
<!--                <div class="txt-card">-->
<!--                  <p class="txt txt-center">-</p>-->
<!--                  <p class="txt txt-center">-</p>-->
<!--                  <p class="txt txt-center">-</p>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT</h5>-->
<!--                </div>-->
<!--                <div class="txt-card pl-60">-->
<!--                  <p class="txt">手柄内置根测</p>-->
<!--                  <p class="txt pl-100">-</p>-->
<!--                  <p class="txt pl-100">-</p>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT Pro</h5>-->
<!--                </div>-->
<!--                <div class="txt-card pl-15">-->
<!--                  <p class="txt">手柄内置根测</p>-->
<!--                  <p class="txt">主机内置根测</p>-->
<!--                  <p class="txt">无线脚踏</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <i class="line"></i>-->

<!--            <div class="mode-function mode-list">-->
<!--              <div class="mode-function-item mode-item pl-5">-->
<!--                <p class="title">Endo GT Mini</p>-->
<!--                <p class="txt">6:1弯机头 * 2</p>-->
<!--                <p class="txt small">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4">手柄 * 1</p>-->
<!--                <p class="txt">主机 * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">电源适配器 * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">充电底座 * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">注油嘴 * 1</p>-->
<!--                <p class="txt">一次性保护套 * 10</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">说明书 * 1</p>-->
<!--                <p class="txt">装箱单 * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item pl-90">-->
<!--                <p class="title">Endo GT</p>-->
<!--                <p class="txt">6:1弯机头 * 2</p>-->
<!--                <p class="txt small">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4">手柄 * 1</p>-->
<!--                <p class="txt">主机 * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">电源适配器 * 1</p>-->
<!--                <p class="txt">锉夹 * 4</p>-->
<!--                <p class="txt">唇钩 * 5</p>-->
<!--                <p class="txt">探针 * 2</p>-->
<!--                <p class="txt">充电底座 * 1</p>-->
<!--                <p class="txt">测量线 * 1</p>-->
<!--                <p class="txt">测试器 * 1</p>-->
<!--                <p class="txt">注油嘴 * 1</p>-->
<!--                <p class="txt">一次性保护套 * 10</p>-->
<!--                <p class="txt">硅胶保护套 * 2</p>-->
<!--                <p class="txt">说明书 * 1</p>-->
<!--                <p class="txt">装箱单 * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item ml-10">-->
<!--                <p class="title">Endo GT Pro</p>-->
<!--                <p class="txt">6:1弯机头 * 2</p>-->
<!--                <p class="txt small">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4">手柄 * 1</p>-->
<!--                <p class="txt">主机 * 1</p>-->
<!--                <p class="txt">无线脚踏 * 1</p>-->
<!--                <p class="txt">电源适配器 * 2</p>-->
<!--                <p class="txt">锉夹 * 4</p>-->
<!--                <p class="txt">唇钩 * 5</p>-->
<!--                <p class="txt">探针 * 2</p>-->
<!--                <p class="txt">充电底座 * 1</p>-->
<!--                <p class="txt">测量线 * 1</p>-->
<!--                <p class="txt">测试器 * 1</p>-->
<!--                <p class="txt">注油嘴 * 1</p>-->
<!--                <p class="txt">一次性保护套 * 10</p>-->
<!--                <p class="txt">硅胶保护套 * 2</p>-->
<!--                <p class="txt">说明书 * 1</p>-->
<!--                <p class="txt">装箱单 * 1</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <i class="line mt-114" ></i>-->

<!--            <div class="specifications-container">-->
<!--              <div class="product-special-title">-->
<!--                <div class="product-special-title-b">-->
<!--                  <p class="txt">参数</p>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="specifications-list ">-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">转速</p>-->
<!--                  <p class="title">Endo GT Pro:50-3100 r/min</p>-->
<!--                  <p class="title ml-50">Endo GT/Endo GT mini:50-3000 r/min</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">扭矩</p>-->
<!--                  <p class="title">0.4-5.0 N·cm</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">转速比</p>-->
<!--                  <p class="title">6:1</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">集成LED</p>-->
<!--                  <p class="title">≥8000 lux</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">模式</p>-->
<!--                  <p class="title">EAL, CW, CCW, REC (SGP), TorqueSense</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash;      <div class="section-bottom-banner">&ndash;&gt;-->
<!--      &lt;!&ndash;        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/39eb92c8dc035af700c6690c0bdf2113.jpg" alt=""/>&ndash;&gt;-->
<!--      &lt;!&ndash;      </div>&ndash;&gt;-->

<!--      <video-modal ref="videoModalRef"></video-modal>-->
<!--    </div>-->
    <specialEndo ></specialEndo>

    <hpfooter></hpfooter>
  </div>
</template>

<script>

// import circularProgress from "../components/endo/progress-circle.vue";
// import endoButton from '../components/endo/button.vue'
// import videoModal from '../components/endo/video-modal.vue'
//
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import hpheader from '../../../common/hpheader.vue'
import hpfooter from '../../../common/hpfooter.vue'
import positionBar from '../../../components/ph-position-bar.vue'
import {session} from "../../../storage/storage"
// gsap.registerPlugin(ScrollTrigger);
import specialEndo from '@/components/special/mobile/endo/index.vue'

//
export default {
  components: {
    positionBar,
    hpfooter,
    hpheader,
    // circularProgress,
    // endoButton,
    // videoModal,
    specialEndo
  },
  data() {
    return {
      showHeader: true,
      is_mounted: false,
      productc_nav: false,
      videoProgress: 0,
      videoIsPlaying: true,
      contraAngleSliderValue: 0,
      valuid:1,
      videoList: [
        {
          ref: 'previewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/796e824f5145403708972671759/oOkSHUvpaWoA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5b5a06b85145403713209442445/sIPEE86eV5IA.mp4',
        },
        {
          ref: 'productVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/473fa3e65145403709194452288/1J1BHLRNKowA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/56a834465145403714488171756/x2huXQ5iuEgA.mp4'
        },
        {
          ref: 'stepVideo1Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fcf2e8ce5145403709301500262/VQfT2rFuHmMA.mp4'
        },
        {
          ref: 'stepVideo2Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/f8eb701c5145403709301390188/araDpiDEcgAA.mp4'
        },
        {
          ref: 'stepVideo3Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/cbbea11d5145403713214694823/WqHRUq4qiicA.mp4'
        },
        {
          ref: 'gPreviewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/7e22f7285145403709306548865/CUggH2zVoPcA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/58c945285145403714488245774/kUesAPotdfcA.mp4'
        },
        {
          ref: 'gModeVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/4284650e5145403715046386999/FtrnNAqgx8cA.mp4'
        },
        {
          ref: 'buildFileVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/920d40355145403714482561310/sIrOk0GeFWkA.mp4'
        },
        {
          ref: 'magneticRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5580c4a05145403714226624469/IPJ9sdHHQnkA.mp4'
        },
      ],
      contraAngleBanner: [
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c6067e872b55e5d6acf177939ac5a0c8.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/b59ba70340db05e588244f83f18a0f8e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/493cc727e1a9b5e616f29a2211ac7104.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/9ead80eb13be4a13f0f3cdc42285c9ff.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/72ce736cd62207015f96a91f83752ce6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/649aa3dd9b0219be20c02dbb3ea41cb4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/040fbcef9345317e6d5f8b63634507eb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/8238944342b81f5b8134ce2b715286e7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6d2c31c66743625370ef787fb2ec1b27.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/de71d210ca45ff166b222da3732253a6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ab90e7a6d3975e0a29c92cf0b6a31417.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/0c819732e2b2468b7fca309e559f25d0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/16a6ce0e7b967e2f87251c7bad80659e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d280151d0cb8197d4aa42a787c454db4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ec6e696ef61b2e74fd5180921dd96b63.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/e6d25395da38d05f2d50bb58f900e4ec.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/a1956fe4da20f7f1e849500bc86a33c7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/da1db807c80ef7d3cda11b17dba77314.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/afc00c7d7b782b7d0d89a67fd164c570.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/7fb5b76f81a3d809d1228a704bc74b20.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/debef22e218b390390be149c6ff5d2a0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/cb6940cd8b4f2b756961b647d2ac8e88.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c68e77cb7327bb6b434b16d420a86eca.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6e13e064ac62342482f6871cf419acfb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/413f3dbb1a3eea85c927879f1b952ef9.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d73bc851d358422a7fa81b61e8c3e8db.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/5d117257f053179f6f41ae8d2f60dab5.jpg',
      ],
      positionNav:[
        // {
        //   title:'Home',
        //   path:'/phhome',
        // },
        // {
        //   title:'Product',
        //   path:'/phproduct',
        // },
        {
          title: 'Endo GT Series',
          path: '/ph/special/endo'
        },
      ],
      channel_id:session.get("channel_id") == '' ? 1 : session.get("channel_id"),
      detail: {},
      value: '产品详情',
      hasUserInteraction: false,
    };
  },
  created(){
    this.ress()
    //
    // if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    //   this.$router.push({path:'/pc/special/endo'})
    // }
  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      this.is_mounted = true
      // _this.$refs.contraAngleAnimationRef.src = _this.contraAngleBanner[_this.contraAngleBanner.length - 1]
      //
      // this.videoList.forEach((item, index) => {
      //   const videoRef = this.$refs[item.ref];
      //   if (videoRef) {
      //
      //   }
      // });

      // setTimeout(() => {
      //   _this.setupVideoIntersectionObserver()
      //   // _this.contraAngleAnimation()
      // }, 500)
      // document.addEventListener('scroll', this.handleScroll, false)
      //
      // this.$once('hook:beforeDestroy', () => {
      //   document.removeEventListener('scroll', this.handleScroll, false)
      // })
    })
  },
  methods: {
    onVideoLoadedData(event, index){
      this.$refs[this.videoList[index].ref].play().catch(e => console.log("视频播放失败:", e));
    },
    ress(){
      var html = document.documentElement; //获取根元素
      var designWidth = 750; //设计稿宽度
      //html.clientWidth 视口宽度
      html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
    },
    openVideoModal(url){
      this.$refs.videoModalRef.open(url)
    },
    listenMove(value){
      if(value < this.contraAngleBanner.length){
        this.$refs.contraAngleAnimationRef.src = this.contraAngleBanner[value]
      }
    },
    contraAngleBannerMove(){

    },
    togglePlay(index) {
      this.videoList[index].playing = !this.videoList[index].playing;
      if(this.videoList[index].playing){
        this.$refs[this.videoList[index].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
      }else {
        this.$refs[this.videoList[index].ref].pause();
      }
    },
    onImageLoad(){
      // this.initScrollAnimation();
    },
    onImprovedBanner(){
      // this.initImprovedBannerAnimation()
    },
    contraAngleAnimation(){
      const _this = this
      const totalLen = this.contraAngleBanner.length
      gsap.timeline({
        scrollTrigger: {
          trigger: ".contra-angle-banner-animate-box",
          start: `top top`,
          end: `+=500`,
          scrub: true,
          pin: true,
          onEnter: () => {
            _this.showHeader = false
          },
          onLeave: () => {

          },
          onUpdate: (self) => {
            let pic = _this.contraAngleBanner[Math.ceil(self.progress * totalLen) - 1]
            if(pic){
              _this.$refs.contraAngleAnimationRef.src = pic
            }

            if(self.progress == 1 || self.progress == 0){
              _this.showHeader = true
            }else {
              _this.showHeader = false
            }
          }
        }
      })
    },
    initImprovedBannerAnimation(){
      gsap.timeline({
        scrollTrigger: {
          trigger: ".improved-container",
          start: `top top`,
          end: `+=2000`,
          scrub: true,
          pin: true,
          onEnter: () => {
          },
        }
      }).to('.improved-banner-text', {
        opacity: 0
      })
          .to('.improved-background', {
            opacity: 1,
          }, '<')
          .to('.improved-content',{
            y: `-100vh`
          }, '<')
    },
    initScrollAnimation(){
      const _this = this

      const bannerElement = document.querySelector('.banner')

      this.videoList.forEach(item => {
        if(this.$refs[item.ref]){
          this.$refs[item.ref].addEventListener('timeupdate', this.onVideoProgress);
        }
      })
      this.setupVideoIntersectionObserver()

      gsap.timeline({
        scrollTrigger: {
          trigger: ".banner-container",
          start: `top top`,
          end: `+=4000`,
          scrub: true,
          pin: true,
          onEnter: () => {
            if (this.$refs[this.videoList[0].ref]) {
              this.$refs[this.videoList[0].ref].currentTime = 0;
              this.videoList[0].playing = true
              this.$refs[this.videoList[0].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
            }
          },
        }
      }).to(this.$refs.previewVideoContainerRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoTextRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoBoxRef, {
        background: 'rgba(0, 0, 0, 0)'
      }, "<")
    },
    setupVideoIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && !this.videoList[index].playing && this.hasUserInteraction) {
              this.$refs[this.videoList[index].ref].play().catch(() => {});
              this.videoList[index].playing = true;
            }
          }else {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && this.videoList[index].playing) {
              this.$refs[this.videoList[index].ref].pause();
              this.$refs[this.videoList[index].ref].currentTime = 0
              this.videoList[index].playing = false;
            }
          }
        });
      }, { threshold: [0.3] });

      this.videoList.forEach(item => {
        const el = this.$refs[item.ref];
        if (el) observer.observe(el);
      });

      const handleFirstInteraction = () => {
        this.hasUserInteraction = true;
        document.removeEventListener('scroll', handleFirstInteraction);
        document.removeEventListener('touchstart', handleFirstInteraction);
      };
      document.addEventListener('scroll', handleFirstInteraction, { once: true });
      document.addEventListener('touchstart', handleFirstInteraction, { once: true });
      // const observer = new IntersectionObserver((entries) => {
      //   entries.forEach(entry => {
      //     if (entry.intersectionRatio === 0) {
      //       this.videoList.forEach(item => {
      //         if (this.$refs[item.ref] === entry.target && item.playing) {
      //           this.$refs[item.ref].pause();
      //           this.$refs[item.ref].currentTime = 0;
      //           item.playing = false;
      //         }
      //       });
      //     } else if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
      //       this.videoList.forEach(item => {
      //         if (this.$refs[item.ref] === entry.target && !item.playing) {
      //           item.playing = true;
      //           this.$refs[item.ref].play().catch(e => {
      //             item.playing = false;
      //             console.log(item.ref + "视频播放失败:", e)
      //           });
      //         }
      //       });
      //     }
      //   });
      // }, {
      //   threshold: [0, 0.1, 0.5, 1.0],
      //   rootMargin: '0px'
      // });
      //
      // this.videoList.forEach(item => {
      //   if (this.$refs[item.ref]) {
      //     observer.observe(this.$refs[item.ref]);
      //   }
      // });
      //
      // this.$once('hook:beforeDestroy', () => {
      //   this.videoList.forEach(item => {
      //     if (this.$refs[item.ref]) {
      //       observer.unobserve(this.$refs[item.ref]);
      //     }
      //   });
      // });
    },
    onVideoProgress(event) {
      const video = event.target;
      const currentTime = video.currentTime;
      const duration = video.duration;

      const videoIndex = this.videoList.findIndex(item => {
        return this.$refs[item.ref] === video;
      });

      if (videoIndex !== -1) {
        this.videoList[videoIndex].progress = ((currentTime / duration) * 100).toFixed(2);
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let head_height = this.$refs.head.getHeaderHeight()
      if (scrollTop > head_height) {
        this.productc_nav = true
        this.scroll_height = scrollTop
      } else {
        this.productc_nav = false
      }
      this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
    },
    selesac(){
      this.valuid=this.value
      let currentRoute = this.$route;
      let query = {...currentRoute.query}
      if(this.valuid == 3){
        query.download = 1
      }else {
        delete query.download
      }
      this.$router.push({
        path: currentRoute.path,
        query: query
      }).then(() => {
        console.log('Query parameter added or updated.');
      });
    },
  },
  beforeDestroy() {
    ScrollTrigger.getAll().forEach(t => t.kill());
  }
};
</script>

<style >

</style>
